<ng-container *transloco="let t">
  <div [class]="labelClass()">
    <label [for]="t(name())" class="text-xs font-medium text-ink tracking-tight">
      {{ t(label()) }} @if (required()) {
      <span class="text-danger"> *</span>
      }
    </label>
  </div>
  <div class="relative">
    @if (prefixIconConfig().icon) {
    <mat-icon
      class="absolute top-1/2 -translate-y-1/2 inset-s-4 pe-2"
      [svgIcon]="prefixIconConfig().icon"
      [class]="prefixIconConfig().iconClasses"
    ></mat-icon>
    }
    <input
      [id]="t(name())"
      [name]="t(name())"
      [class]="appliedClasses()"
      [placeholder]="t(placeholder())"
      [type]="type()"
      [attr.maxlength]="maxLength() ?? null"
      class="form-input"
      [class.ps-10!]="prefixIconConfig().icon"
      [disabled]="disabled()"
      [readonly]="pending()"
      [class.disabled]="disabled()"
      [class.input-error]="showError()"
      #input
      [value]="value() ?? ''"
      (input)="type() === 'number' && value() ? value.set(input.valueAsNumber) : value.set(input.value.trim())"
      (blur)="touch.emit()"
      [attr.aria-busy]="pending()"
      [attr.aria-invalid]="showError()"
    />
  </div>
  @if (showError()) {
  <!-- `role="alert"` announces the message when it appears; `aria-describedby` above ties it
         to the group for anyone who navigates back to it. WCAG 2.2 SC 3.3.1. -->
  <div [id]="controlId() + '-error'" role="alert">
    <juno-libs-ui-error [errors]="errors()"></juno-libs-ui-error>
  </div>
  }
</ng-container>
